import IndiaFlagIcon from "../assets/images/in.svg";
import UaeFlagIcon from "../assets/images/ae.svg";
export const COUNTRIES = [
  {
    id: 1,
    iso: "in",
    nicename: "India",
    phonecode: "+91",
    flag: IndiaFlagIcon
  },
  {
    id: 2,
    iso: "ae",
    nicename: "United Arab Emirates",
    phonecode: "+971",
    flag: UaeFlagIcon
  }
];
export const TIME_ZONES = [
  {
    id: 1,
    value: "ist",
    nicename: "Indian Standard Time"
  },
  {
    id: 2,
    value: "gst",
    nicename: "United Arab Emirates Time"
  }
];
